module.exports = __webpack_public_path__ + "img/color_signature_a-1598-6.4f46771.webp";